/** Captured from Clients List Missing Profile Data tabs. */
export const LIST_MISSING_SETTINGS = {
  "tabs": [
    {
      "id": "all",
      "label": "ALL",
      "title": "All",
      "type": "All",
      "selectAllId": "applyToallcheckin",
      "rows": [
        {
          "value": "ADMISSION DATE",
          "label": "ADMISSION DATE",
          "checked": true
        },
        {
          "value": "CLIENT NAME",
          "label": "CLIENT NAME",
          "checked": true
        },
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "checked": true
        },
        {
          "value": "GENDER",
          "label": "GENDER",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "PROFILE PIC",
          "label": "PROFILE PIC",
          "checked": true
        },
        {
          "value": "MARITAL STATUS",
          "label": "MARITAL STATUS",
          "checked": true
        },
        {
          "value": "SOCIAL SECURITY",
          "label": "SOCIAL SECURITY",
          "checked": true
        },
        {
          "value": "EMERGENCY CONTACT",
          "label": "EMERGENCY CONTACT",
          "checked": true
        },
        {
          "value": "PRIMARY PHYSICIAN",
          "label": "PRIMARY PHYSICIAN",
          "checked": true
        },
        {
          "value": "PRIMARY PHARMACIST",
          "label": "PRIMARY PHARMACIST",
          "checked": true
        },
        {
          "value": "CLIENT SIGNATURE FIELD",
          "label": "CLIENT SIGNATURE FIELD",
          "checked": false
        },
        {
          "value": "GPS LOCATION",
          "label": "GPS LOCATION",
          "checked": true
        },
        {
          "value": "SCHEDULED DAYS",
          "label": "SCHEDULED DAYS",
          "checked": true
        },
        {
          "value": "SCHEDULED SHIFT",
          "label": "SCHEDULED SHIFT",
          "checked": true
        },
        {
          "value": "TRANSPORTATION DAYS",
          "label": "TRANSPORTATION DAYS",
          "checked": true
        },
        {
          "value": "TRANSPORTATION SHIFT",
          "label": "TRANSPORTATION SHIFT",
          "checked": true
        },
        {
          "value": "PICK-UP ROUTE",
          "label": "PICK-UP ROUTE",
          "checked": true
        },
        {
          "value": "DROP-OFF ROUTE",
          "label": "DROP-OFF ROUTE",
          "checked": true
        },
        {
          "value": "PICK-UP DRIVER",
          "label": "PICK-UP DRIVER",
          "checked": true
        },
        {
          "value": "DROP-OFF DRIVER",
          "label": "DROP-OFF DRIVER",
          "checked": true
        },
        {
          "value": "ELIGIBILITY VERIFICATION",
          "label": "ELIGIBILITY VERIFICATION(Active)",
          "checked": true
        },
        {
          "value": "BILLING DIAGNOSIS CODE",
          "label": "BILLING DIAGNOSIS CODE",
          "checked": true
        },
        {
          "value": "PAYER NAME",
          "label": "PAYER NAME",
          "checked": true
        },
        {
          "value": "MODIFIER CODE",
          "label": "MODIFIER CODE",
          "checked": true
        },
        {
          "value": "HMO ID",
          "label": "HMO MEMBER ID",
          "checked": true
        },
        {
          "value": "MEDICAID ID",
          "label": "MEDICAID ID",
          "checked": true
        },
        {
          "value": "ALLERGIES NAME",
          "label": "ALLERGIES NAME",
          "checked": true
        },
        {
          "value": "CODE STATUS",
          "label": "CODE STATUS",
          "checked": true
        },
        {
          "value": "ADL PROFILE",
          "label": "ADL PROFILE",
          "checked": true
        },
        {
          "value": "VITAL PROFILE",
          "label": "VITAL PROFILE",
          "checked": true
        },
        {
          "value": "VITAL RANGE",
          "label": "VITAL RANGE",
          "checked": true
        },
        {
          "value": "MARS CHART",
          "label": "MARS CHART",
          "checked": true
        },
        {
          "value": "SUBMITTED DATE",
          "label": "SUBMITTED DATE",
          "checked": true
        },
        {
          "value": "ENROLLMENT DATE",
          "label": "ENROLLMENT DATE",
          "checked": true
        },
        {
          "value": "CACFP DETERMINATION",
          "label": "CACFP DETERMINATION (F,R,P)",
          "checked": true
        },
        {
          "value": "MEALS",
          "label": "MEALS (B,A,L,S,PM)",
          "checked": true
        },
        {
          "value": "CLIENT ID",
          "label": "CLIENT ID#",
          "checked": true
        },
        {
          "value": "HOME PHONE",
          "label": "HOME PHONE",
          "checked": true
        },
        {
          "value": "CELL PHONE",
          "label": "CELL PHONE",
          "checked": true
        },
        {
          "value": "CLIENT EMAIL ID",
          "label": "CLIENT EMAIL ID",
          "checked": true
        },
        {
          "value": "GUARDIAN",
          "label": "GUARDIAN",
          "checked": true
        },
        {
          "value": "PRIMARY LANGUAGE",
          "label": "PRIMARY LANGUAGE",
          "checked": true
        },
        {
          "value": "SECONDARY LANGUAGE",
          "label": "SECONDARY LANGUAGE",
          "checked": true
        },
        {
          "value": "ETHNICITY",
          "label": "ETHNICITY",
          "checked": true
        },
        {
          "value": "AUTH CODE",
          "label": "AUTH CODE",
          "checked": true
        },
        {
          "value": "SECONDARY PAYER",
          "label": "SECONDARY PAYER",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List - clieent misting tab all .html"
    },
    {
      "id": "admission",
      "label": "ADMISSION",
      "title": "ADMISSION",
      "type": "Admission",
      "selectAllId": "applyToallcheckinAdmission",
      "rows": [
        {
          "value": "ADMISSION DATE",
          "label": "ADMISSION DATE",
          "checked": true
        },
        {
          "value": "CLIENT NAME",
          "label": "CLIENT NAME",
          "checked": true
        },
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "checked": true
        },
        {
          "value": "GENDER",
          "label": "GENDER",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "PROFILE PIC",
          "label": "PROFILE PIC",
          "checked": true
        },
        {
          "value": "MARITAL STATUS",
          "label": "MARITAL STATUS",
          "checked": true
        },
        {
          "value": "SOCIAL SECURITY",
          "label": "SOCIAL SECURITY",
          "checked": true
        },
        {
          "value": "EMERGENCY CONTACT",
          "label": "EMERGENCY CONTACT",
          "checked": true
        },
        {
          "value": "PRIMARY PHYSICIAN",
          "label": "PRIMARY PHYSICIAN",
          "checked": true
        },
        {
          "value": "PRIMARY PHARMACIST",
          "label": "PRIMARY PHARMACIST",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List - ADMISSION.html"
    },
    {
      "id": "shiftschedule1",
      "label": "SHIFT SCHEDULE",
      "title": "SHIFT SCHEDULE",
      "type": "Shift",
      "selectAllId": "applyToallcheckinShift",
      "rows": [
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "GPS LOCATION",
          "label": "GPS LOCATION",
          "checked": true
        },
        {
          "value": "SCHEDULED DAYS",
          "label": "SCHEDULED DAYS",
          "checked": true
        },
        {
          "value": "SCHEDULED SHIFT",
          "label": "SCHEDULED SHIFT",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List - SHIFT SCHEDULE.html"
    },
    {
      "id": "transportationschedule",
      "label": "TRANSPORTATION SCHEDULE",
      "title": "TRANSPORTATION SCHEDULE",
      "type": "Transportation",
      "selectAllId": "applyToallcheckinTransportation",
      "rows": [
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "GPS LOCATION",
          "label": "GPS LOCATION",
          "checked": true
        },
        {
          "value": "SCHEDULED DAYS",
          "label": "SCHEDULED DAYS",
          "checked": true
        },
        {
          "value": "SCHEDULED SHIFT",
          "label": "SCHEDULED SHIFT",
          "checked": true
        },
        {
          "value": "TRANSPORTATION DAYS",
          "label": "TRANSPORTATION DAYS",
          "checked": true
        },
        {
          "value": "TRANSPORTATION SHIFT",
          "label": "TRANSPORTATION SHIFT",
          "checked": true
        },
        {
          "value": "PICK-UP ROUTE",
          "label": "PICK-UP ROUTE",
          "checked": true
        },
        {
          "value": "DROP-OFF ROUTE",
          "label": "DROP-OFF ROUTE",
          "checked": true
        },
        {
          "value": "PICK-UP DRIVER",
          "label": "PICK-UP DRIVER",
          "checked": true
        },
        {
          "value": "DROP-OFF DRIVER",
          "label": "DROP-OFF DRIVER",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List - TRANSPORTATION SCHEDULE.html"
    },
    {
      "id": "foodprogram",
      "label": "FOOD (CACFP) PROGRAM",
      "title": "FOOD (CACFP) PROGRAM",
      "type": "Food",
      "selectAllId": "applyToallcheckinFood",
      "rows": [
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "checked": true
        },
        {
          "value": "GENDER",
          "label": "GENDER",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "SUBMITTED DATE",
          "label": "SUBMITTED DATE",
          "checked": true
        },
        {
          "value": "ENROLLMENT DATE",
          "label": "ENROLLMENT DATE",
          "checked": true
        },
        {
          "value": "CACFP DETERMINATION",
          "label": "CACFP DETERMINATION (F,R,P)",
          "checked": true
        },
        {
          "value": "MEALS",
          "label": "MEALS (B,A,L,S,PM)",
          "checked": true
        },
        {
          "value": "DAILY MEALS",
          "label": "DAILY MEALS",
          "checked": true
        },
        {
          "value": "DIET PLAN",
          "label": "DIET PLAN",
          "checked": true
        },
        {
          "value": "FOOD PROGRAM",
          "label": "FOOD PROGRAM",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List - FOOD (CACFP) PROGRAM.html"
    },
    {
      "id": "priorauthorizition",
      "label": "PRIOR AUTHORIZTION",
      "title": "PRIOR AUTHORIZTION",
      "type": "Prior",
      "selectAllId": "applyToallcheckinPA",
      "rows": [
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "checked": true
        },
        {
          "value": "GENDER",
          "label": "GENDER",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "ELIGIBILITY VERIFICATION",
          "label": "ELIGIBILITY VERIFICATION(Active)",
          "checked": true
        },
        {
          "value": "BILLING DIAGNOSIS CODE",
          "label": "BILLING DIAGNOSIS CODE",
          "checked": true
        },
        {
          "value": "PAYER NAME",
          "label": "PAYER NAME",
          "checked": true
        },
        {
          "value": "MODIFIER CODE",
          "label": "MODIFIER CODE",
          "checked": true
        },
        {
          "value": "HMO ID",
          "label": "HMO MEMBER ID",
          "checked": true
        },
        {
          "value": "MEDICAID ID",
          "label": "MEDICAID ID",
          "checked": true
        },
        {
          "value": "AUTH CODE",
          "label": "AUTH CODE",
          "checked": true
        },
        {
          "value": "SECONDARY PAYER",
          "label": "SECONDARY PAYER",
          "checked": true
        },
        {
          "value": "PRIMARY PHYSICIAN",
          "label": "PRIMARY PHYSICIAN",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List - PRIOR AUTHORIZTION.html"
    },
    {
      "id": "clinical",
      "label": "CLINICAL",
      "title": "CLINICAL",
      "type": "Clinical",
      "selectAllId": "applyToallcheckinClinical",
      "rows": [
        {
          "value": "FIRST NAME",
          "label": "FIRST NAME",
          "checked": true
        },
        {
          "value": "LAST NAME",
          "label": "LAST NAME",
          "checked": true
        },
        {
          "value": "MIDDLE NAME",
          "label": "MIDDLE NAME",
          "checked": true
        },
        {
          "value": "DATE OF BIRTH",
          "label": "DATE OF BIRTH",
          "checked": true
        },
        {
          "value": "GENDER",
          "label": "GENDER",
          "checked": true
        },
        {
          "value": "ADDRESS1",
          "label": "ADDRESS1",
          "checked": true
        },
        {
          "value": "CITY",
          "label": "CITY",
          "checked": true
        },
        {
          "value": "STATE",
          "label": "STATE",
          "checked": true
        },
        {
          "value": "ZIP CODE",
          "label": "ZIP CODE",
          "checked": true
        },
        {
          "value": "ALLERGIES NAME",
          "label": "ALLERGIES NAME",
          "checked": true
        },
        {
          "value": "CODE STATUS",
          "label": "CODE STATUS",
          "checked": true
        },
        {
          "value": "ADL PROFILE",
          "label": "ADL PROFILE",
          "checked": true
        },
        {
          "value": "VITAL PROFILE",
          "label": "VITAL PROFILE",
          "checked": true
        },
        {
          "value": "VITAL RANGE",
          "label": "VITAL RANGE",
          "checked": true
        },
        {
          "value": "MARS CHART",
          "label": "MARS CHART",
          "checked": true
        }
      ],
      "source": "My Adult day care\u00a0_\u00a0Clients List- CLINICAL.html"
    }
  ],
  "dccId": "129"
} as const
